import axios from 'axios'

// * Auth Service

export const updateUserInfo = async (payload) => {
  return await axios.put(
    `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/user/userinfo`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    }
  )
}

export const getUserInfo = async () => {
  return await axios.get(`${import.meta.env.VITE_STUDENT_IAM_URL}/auth/userinfo`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
    },
    'Content-Type': 'application/json',
  })
}
